<template>
  <div class="container" v-if="!isLoading">
    <div class="row">
      <div class="col-12">
        <TopNav class="mt-4" />
        <img class="mt-3" :srcset="`${logo} 3x`" />
        <p class="mt-4 mb-4">
          {{ $t('SETTINGS.TEXT.ADD_A_SENSE_OF_URGENCY_TO_CHECKOUT') }}
        </p>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="deadline_funnel_tracking_code_parser">
            {{ $t('SETTINGS.LABEL.PASTE_YOUR_DEADLINE_FUNNEL_TRACKING_CODE') }}
          </label>
          <textarea
            id="deadline_funnel_tracking_code_parser"
            class="form-control"
            rows="8"
            v-model="deadlineFunnelTrackingCode"
          ></textarea>
        </div>
        <HMTextInput
          :label="$t('SETTINGS.LABEL.DEADLINE_FUNNEL_KEY')"
          v-model="deadlineFunnelKey"
        ></HMTextInput>
      </div>
      <hr class="mx-3 w-100" />
      <div class="col-12 form-group">
        <HMButton color="primary" @click="update" :loading="inProgress">
          {{ $t('SETTINGS.BUTTON.UPDATE') }}
        </HMButton>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import TopNav from '@/web/components/navigation/TopNav.vue';
import { errorToMessage } from '@/core/utils/errors';

function extractUrlValue(key, url) {
  if (typeof url === 'undefined') url = window.location.href;
  const match = url.match('[?&]' + key + '=([^&]+)');
  return match ? match[1] : null;
}

export default Vue.extend({
  name: 'DeadlineFunnelIntegration',
  components: {
    TopNav,
  },
  data() {
    return {
      logo: '/assets/images/integrations/deadline-funnel@3x.png',
      isLoading: true,
      inProgress: false,
      deadlineFunnelKey: null,
      deadlineFunnelTrackingCode: '',
    };
  },
  methods: {
    async update() {
      this.inProgress = true;

      if (this.deadlineFunnelTrackingCode) {
        this.deadlineFunnelKey = extractUrlValue(
          'userIdHash',
          this.deadlineFunnelTrackingCode
        );
        this.deadlineFunnelTrackingCode = '';
      }

      try {
        await this.$store.dispatch(
          'setting/updateDeadlineFunnelKey',
          this.deadlineFunnelKey
        );
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'SETTINGS.NOTIFICATIONS.DEADLINE_FUNNEL_KEY_SUCCESSFULLY_UPDATED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
      }
      this.inProgress = false;
    },
    remove() {
      this.deadlineFunnelKey = null;
      this.update();
    },
  },
  async mounted() {
    this.deadlineFunnelKey = await this.$store.dispatch(
      'setting/getDeadlineFunnelKey'
    );
    this.isLoading = false;
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
